/**
 * The shareable address of a newsletter section: the given URL with the section
 * in the query string and no fragment, or without either when there is no
 * section.
 */
export const getNewsletterSectionUrl = (
	url: string | URL,
	sectionId: string | null | undefined
) => {
	const sectionUrl = new URL(url);

	sectionUrl.hash = '';

	if (sectionId) {
		sectionUrl.searchParams.set('section', sectionId);
	} else {
		sectionUrl.searchParams.delete('section');
	}

	return sectionUrl.toString();
};
